

export class Identificacion {
    ididentificacion: string;
    iditem: string;
    corriente_artistica: string;
    datacion: string;
}
